export default __webpack_public_path__ + "static/media/llama.0c732913.svg";